export function _teacher (teacher) {
  return {
    // Number
    id: teacher?.id,
    // String
    fullName: teacher?.fullname,
    // String
    firstName: teacher?.first_name,
    // String
    lastName: teacher?.last_name,
    // String
    username: teacher?.username,
    // String
    chatUsername: teacher?.chat_username,
    // String --link--
    teacherPage: teacher?.teacher_page,
    // String --link--
    picture: teacher?.picture,
    // String
    gender: teacher?.gender,
    // Object
    // @params {total_sessions,active_students,total_feedbacks,overall_average_feedbacks,maximum_average_feedbacks}
    statistics: teacher?.statistics,
    // Object
    // @params {title,description}
    about: teacher?.teacher_about,
    // Object
    // @params {name,flag,two_words,three_words}
    country: teacher?.country,
    // Object
    // @params {teaching{name,flag},speaking[{name,flag,level}]}
    language: teacher?.language,
    // Array
    // @params [{course_id,name}]
    teachingCourses: teacher?.teaching_courses,
    // null
    video: teacher?.teacher_video,
    // Object
    // @params {final_price,old_price,off_percent,session_time}
    teachingPrice: teacher?.teaching_price,
    // Object
    teacherHighlights: teacher?.teacher_highlights,
    // Object
    bestStudentComment: teacher?.best_student_comment,
    designColor: teacher?.design_color?.toLowerCase()
  }
}
